import { v4 as uuid } from "uuid";
import { formatDate } from "../utils/authUtils";
import { vishalGaurav, tanayPratap, bhavishAggarwal } from "../utils/images";
/**
 * User Database can be added here.
 * You can add default users of your wish with different attributes
 * */

export const users = [
  {
    _id: uuid(),
    firstName: "Vishal",
    lastName: "Gaurav",
    username: "vishalg8454",
    email: "vishalg.mca21@nitp.ac.in",
    password: "secretpassword",
    createdAt: formatDate(),
    updatedAt: formatDate(),
    bio: "bio mein interest hota toh aaj mai doctor hota",
    profileImage: vishalGaurav,
    backgroundImage: `https://res.cloudinary.com/dwqdlzlek/image/upload/v1654089074/shashi_maurya_background_jcg8bi.jpg`,
    website: `github.com/vishalg8454`,
    followers: [
      {
        firstName: "Tanay",
        lastName: "Pratap",
        username: "tanaypratap",
        profileImage: tanayPratap,
      },
      {
        firstName: `Kunal`,
        lastName: `Shah`,
        username: `kunalb11`,
        profileImage: `https://res.cloudinary.com/dwqdlzlek/image/upload/v1654090092/kunal_shah_nvoz1m.jpg`,
      },
      {
        firstName: `Suumit`,
        lastName: `Shah`,
        username: `suumitshah`,
        profileImage: bhavishAggarwal,
      },
      {
        firstName: `Bhavish`,
        lastName: ` Aggarwal`,
        username: `bhash`,
        profileImage: bhavishAggarwal,
      },
      {
        firstName: `Anupam`,
        lastName: `Mittal`,
        username: `AnupamMittal`,
        profileImage: `https://res.cloudinary.com/dwqdlzlek/image/upload/v1654092599/anupam_mittal_owirks.jpg`,
      },
    ],
    following: [
      {
        firstName: "Tanay",
        lastName: "Pratap",
        username: "tanaypratap",
        profileImage: tanayPratap,
      },
      {
        firstName: `Kunal`,
        lastName: `Shah`,
        username: `kunalb11`,
        profileImage: `https://res.cloudinary.com/dwqdlzlek/image/upload/v1654090092/kunal_shah_nvoz1m.jpg`,
      },
      {
        firstName: `Suumit`,
        lastName: `Shah`,
        username: `suumitshah`,
        profileImage: bhavishAggarwal,
      },
      {
        firstName: `Bhavish`,
        lastName: ` Aggarwal`,
        username: `bhash`,
        profileImage: bhavishAggarwal,
      },
      {
        firstName: `Anupam`,
        lastName: `Mittal`,
        username: `AnupamMittal`,
        profileImage: `https://res.cloudinary.com/dwqdlzlek/image/upload/v1654092599/anupam_mittal_owirks.jpg`,
      },
    ],
  },
  {
    _id: uuid(),
    firstName: "Tanay",
    lastName: "Pratap",
    username: "tanaypratap",
    email: "tanaypratap@gmail.com",
    password: "secretpassword",
    createdAt: formatDate(),
    updatedAt: formatDate(),
    bio: `Founder  @invactHQ| x @Microsoft
     | Fixing education | Mentored 100+ students to first tech job | Tweets: Tech, Education, Career, Metaverse and Startups`,
    profileImage: tanayPratap,
    backgroundImage: `https://res.cloudinary.com/dwqdlzlek/image/upload/v1654094890/tanay_pratap_background_vajqoq.jpg`,
    website:"https://tanaypratap.com/",
    followers: [
      {
        firstName: `Kunal`,
        lastName: `Shah`,
        username: `kunalb11`,
        profileImage: `https://res.cloudinary.com/dwqdlzlek/image/upload/v1654090092/kunal_shah_nvoz1m.jpg`,
      },
      {
        firstName: `Suumit`,
        lastName: `Shah`,
        username: `suumitshah`,
        profileImage: bhavishAggarwal,
      },
      {
        firstName: `Bhavish`,
        lastName: ` Aggarwal`,
        username: `bhash`,
        profileImage: bhavishAggarwal,
      },
    ],
    following: [
      {
        firstName: `Suumit`,
        lastName: `Shah`,
        username: `suumitshah`,
        profileImage: bhavishAggarwal,
      },
      {
        firstName: `Bhavish`,
        lastName: ` Aggarwal`,
        username: `bhash`,
        profileImage: `https://res.cloudinary.com/dwqdlzlek/image/upload/v1654091110/bhavish_aggarwal_pc948b.jpg`,
      },
      {
        firstName: `Anupam`,
        lastName: `Mittal`,
        username: `AnupamMittal`,
        profileImage: `https://res.cloudinary.com/dwqdlzlek/image/upload/v1654092599/anupam_mittal_owirks.jpg`,
      },
    ],
  },
  {
    _id: uuid(),
    firstName: "Kunal",
    lastName: "Shah",
    username: "kunalb11",
    email: "KunalShah@gmail.com",
    password: "secretpassword",
    createdAt: formatDate(),
    updatedAt: formatDate(),
    bio: "cred karo khush reho",
    profileImage: `https://res.cloudinary.com/dwqdlzlek/image/upload/v1654090092/kunal_shah_nvoz1m.jpg`,
    backgroundImage: `https://res.cloudinary.com/dwqdlzlek/image/upload/v1654094890/tanay_pratap_background_vajqoq.jpg`,
    website: "https://cred.club/",
    backgroundImage: null,
    followers: [
      {
        firstName: `Suumit`,
        lastName: `Shah`,
        username: `suumitshah`,
        profileImage: bhavishAggarwal,
      },
      {
        firstName: `Bhavish`,
        lastName: ` Aggarwal`,
        username: `bhash`,
        profileImage: bhavishAggarwal,
      },
    ],
    following: [
      {
        firstName: `Vishal`,
        lastName: `Gaurav`,
        username: "vishalg8454",
        profileImage: vishalGaurav,
      },
      {
        firstName: "Tanay",
        lastName: "Pratap",
        username: "tanaypratap",
        profileImage: tanayPratap,
      },
      {
        firstName: `Bhavish`,
        lastName: ` Aggarwal`,
        username: `bhash`,
        profileImage: bhavishAggarwal,
      },
    ],
  },

  {
    _id: uuid(),
    firstName: "Suumit",
    lastName: "Shah",
    username: "suumitshah",
    email: "suumitshah@gmail.com",
    password: "secretpassword",
    createdAt: formatDate(),
    updatedAt: formatDate(),
    bio: "Founder, Dukaan®",
    profileImage: `https://res.cloudinary.com/dwqdlzlek/image/upload/v1654090778/suumit_shah_mn2nhk.jpg`,
    backgroundImage: `https://res.cloudinary.com/dwqdlzlek/image/upload/v1654098623/summit_shah_background_fffbxg.jpg`,
    website: `https://mydukaan.io/`,
    followers: [
      {
        firstName: "Tanay",
        lastName: "Pratap",
        username: "tanaypratap",
        profileImage: tanayPratap,
      },
      {
        firstName: `Bhavish`,
        lastName: ` Aggarwal`,
        username: `bhash`,
        profileImage: bhavishAggarwal,
      },
      {
        firstName: `Anupam`,
        lastName: `Mittal`,
        username: `AnupamMittal`,
        profileImage: `https://res.cloudinary.com/dwqdlzlek/image/upload/v1654092599/anupam_mittal_owirks.jpg`,
      },
    ],
    following: [
      {
        firstName: "Tanay",
        lastName: "Pratap",
        username: "tanaypratap",
        profileImage: tanayPratap,
      },
      {
        firstName: `Kunal`,
        lastName: `Shah`,
        username: `kunalb11`,
        profileImage: `https://res.cloudinary.com/dwqdlzlek/image/upload/v1654090092/kunal_shah_nvoz1m.jpg`,
      },
      {
        firstName: `Bhavish`,
        lastName: ` Aggarwal`,
        username: `bhash`,
        profileImage: bhavishAggarwal,
      },
      {
        firstName: `Anupam`,
        lastName: `Mittal`,
        username: `AnupamMittal`,
        profileImage: `https://res.cloudinary.com/dwqdlzlek/image/upload/v1654092599/anupam_mittal_owirks.jpg`,
      },
      {
        firstName: `Vishal`,
        lastName: `Gaurav`,
        username: "vishalg8454",
        profileImage: vishalGaurav,
      },
    ],
  },
  {
    _id: uuid(),
    firstName: "Bhavish",
    lastName: "Aggarwal",
    username: "bhash",
    email: "bhavishaggarwal@gmail.com",
    password: "secretpassword",
    createdAt: formatDate(),
    updatedAt: formatDate(),
    bio: `Building the future at Ola!
    `,
    profileImage: bhavishAggarwal,
    backgroundImage: `https://res.cloudinary.com/dwqdlzlek/image/upload/v1654100040/bhavish_aggarwal_background_vo5fmw.jpg`,
    website: `https://t.co/2fukVxoHsx`,
    followers: [
      {
        firstName: "Tanay",
        lastName: "Pratap",
        username: "tanaypratap",
        profileImage: tanayPratap,
      },
      {
        firstName: `Kunal`,
        lastName: `Shah`,
        username: `kunalb11`,
        profileImage: `https://res.cloudinary.com/dwqdlzlek/image/upload/v1654090092/kunal_shah_nvoz1m.jpg`,
      },
      {
        firstName: `Suumit`,
        lastName: `Shah`,
        username: `suumitshah`,
        profileImage: bhavishAggarwal,
      },
    ],
    following: [
      {
        firstName: `Vishal`,
        lastName: `Gaurav`,
        username: "vishalg8454",
        profileImage: vishalGaurav,
      },
      {
        firstName: "Tanay",
        lastName: "Pratap",
        username: "tanaypratap",
        profileImage: tanayPratap,
      },
      {
        firstName: `Kunal`,
        lastName: `Shah`,
        username: `kunalb11`,
        profileImage: `https://res.cloudinary.com/dwqdlzlek/image/upload/v1654090092/kunal_shah_nvoz1m.jpg`,
      },
      {
        firstName: `Suumit`,
        lastName: `Shah`,
        username: `suumitshah`,
        profileImage: bhavishAggarwal,
      },
    ],
  },
  {
    _id: uuid(),
    firstName: "Anupam",
    lastName: "Mittal",
    username: "AnupamMittal",
    email: "AnupamMittal@gmail.com",
    password: "secretpassword",
    createdAt: formatDate(),
    updatedAt: formatDate(),
    bio: `Founder-People Group, Shaadi.com | Tech/Brand Investor | Shark`,
    profileImage: `https://res.cloudinary.com/dwqdlzlek/image/upload/v1654092599/anupam_mittal_owirks.jpg`,
    backgroundImage: `https://res.cloudinary.com/dwqdlzlek/image/upload/v1654101166/anupam_mittal_background_tlcaxw.jpg`,
    followers: [
      {
        firstName: "Tanay",
        lastName: "Pratap",
        username: "tanaypratap",
        profileImage: tanayPratap,
      },
      {
        firstName: `Kunal`,
        lastName: `Shah`,
        username: `kunalb11`,
        profileImage: `https://res.cloudinary.com/dwqdlzlek/image/upload/v1654090092/kunal_shah_nvoz1m.jpg`,
      },
      {
        firstName: `Suumit`,
        lastName: `Shah`,
        username: `suumitshah`,
        profileImage: bhavishAggarwal,
      },
      {
        firstName: `Bhavish`,
        lastName: ` Aggarwal`,
        username: `bhash`,
        profileImage: `https://res.cloudinary.com/dwqdlzlek/image/upload/v1654091110/bhavish_aggarwal_pc948b.jpg`,
      },
    ],
    following: [
      {
        firstName: `Vishal`,
        lastName: `Gaurav`,
        username: "vishalg8454",
        profileImage: vishalGaurav,
      },
      {
        firstName: "Tanay",
        lastName: "Pratap",
        username: "tanaypratap",
        profileImage: tanayPratap,
      },
      {
        firstName: `Kunal`,
        lastName: `Shah`,
        username: `kunalb11`,
        profileImage: `https://res.cloudinary.com/dwqdlzlek/image/upload/v1654090092/kunal_shah_nvoz1m.jpg`,
      },
      {
        firstName: `Suumit`,
        lastName: `Shah`,
        username: `suumitshah`,
        profileImage: bhavishAggarwal,
      },
    ],
  },
];
